<template>
<div >
<v-card style="margin-top: 250px">
  <h1 align="center" style="text-decoration: underline overline;"></h1>
  <br/>
   <v-text-field
    outlined 
    dense
    rounded
    v-model="HID"
    label="HID"
    width="20px"
    disabled
  ></v-text-field>


  <v-row v-show="S == 2">
    <v-btn 
      v-if="userData.role !== 'RESPONDENT'"
      class="ml-4" 
      color="light-blue white--text" 
      @click="butangPengesahan()"
    >
      <span class="material-icons">add</span>{{$t('Pautan ke Imbangan')}}
    </v-btn>
  </v-row>


<v-card class="mt-4">

  <v-card-title style="text-decoration: underline overline;">
    RINGKASAN PENDAPATAN ISI RUMAH 
  </v-card-title>  

  <v-card-text>
    <v-simple-table 
    fixed-header
    dense>
      <thead>
        <tr>
          <th class="text-h6 orange lighten-4" ><strong>
            PENGESAHAN
          </strong></th>

          <th class="text-h6 orange lighten-4">
           
          </th>

          <th class="text-h6 orange lighten-4" v-for="item in summaryData.dataJR5" 
            :key="item.NOAIR">
            <v-btn x-small rounded color="primary" @click="pengesahanDataAir(item)">Pengesahan AIR {{item.NOAIR}}</v-btn>
          </th>

          <th style="text-align:center;" class="text-h6 orange lighten-4">
            
          </th>  
        </tr>
        <tr>
          <th class="text-h6 orange lighten-4" ><strong>
            PUNCA PENDAPATAN
          </strong></th>

          <th class="text-h6 orange lighten-4">
            KOD INCS
          </th>

          <th class="text-h6 orange lighten-4 text-center" v-for="item in summaryData.dataJR5" 
            :key="item.NOAIR">
            {{item.NOAIR}}
          </th>

          <th style="text-align:center;" class="text-h6 orange lighten-4">
            JUMLAH PENDAPATAN <br>ISI RUMAH
          </th>  
        </tr>
      </thead>

      <tbody>
        <tr>
              <th colspan="10" style="text-align:center;"  class="text-h6 green lighten-3"><strong>PENDAPATAN BERGAJI</strong></th>
        </tr>

        <!-- INCS11 -->
        <tr>
          <td>Upah dan gaji</td>

          <td>INCS11</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS11}}
          </td>

          <td style="text-align:center;" > {{totalINCS11}}</td>

        </tr>

        <!-- INCS12 -->
        <tr>
          <td>Elaun</td>

          <td>INCS12</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS12}}
          </td>

          <td style="text-align:center;" >{{totalINCS12}}</td>

        </tr>

        <!-- INCS13 -->
        <tr>
          <td>Bonus</td>

          <td>INCS13</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS13}}
          </td>

          <td style="text-align:center;" >{{totalINCS13}}</td>

        </tr>

        <!-- INCS14 -->
        <tr>
          <td>Wang Tunai lain</td>

          <td>INCS14</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS14}}
          </td>

          <td style="text-align:center;" >{{totalINCS14}}</td>

        </tr>

        <!-- INCS15 -->
        <tr>
          <td>Makanan percuma/konsesi</td>

          <td>INCS15</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center"> 
            {{item.INCS15}}
          </td>

          <td style="text-align:center;" >{{totalINCS15}}</td>
        </tr>

        <!-- INCS16 -->
        <tr>
          <td>Tempat menginap percuma/konsesi</td>

          <td>INCS16</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS16}}
          </td>

          <td style="text-align:center;" >{{totalINCS16}}</td>

        </tr>

        <!-- INCS17 -->
        <tr>
          <td>Barang pengguna dan perkhidmatan percuma/konsesi</td>

          <td>INCS17</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS17}}
          </td>

          <td style="text-align:center;" >{{totalINCS17}}</td>

        </tr>

        <!-- INCS18 -->
        <tr>
          <td>Pembayaran lain yang diterima berupa mata benda</td>

          <td>INCS18</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS18}}
          </td>

          <td style="text-align:center;" >{{totalINCS18}}</td>

        </tr>

        <!-- INCS19a -->
        <tr>
          <td>a. KWSP</td>

          <td>INCS19a</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS19_a}}
          </td>

          <td style="text-align:center;" >{{totalINCS19_a}}</td>

        </tr>

        <!-- INCS19b -->
        <tr>
          <td>b. PERKESO</td>

          <td>INCS19b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS19_b}}
          </td>

          <td style="text-align:center;" >{{totalINCS19_b}}</td>

        </tr>

        <!-- INCS19c -->
        <tr>
          <td>c. Lain - lain</td>

          <td>INCS19c</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS19_c}}
          </td>

          <td style="text-align:center;" >{{totalINCS19_c}}</td>

        </tr>

        <!-- INCS19 -->
        <tr>
          <td><strong>JUMLAH CARUMAN OLEH MAJIKAN</strong></td>

          <td><strong>INCS19</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS19}}
          </td>

          <td style="text-align:center;" >{{totalINCS19}}</td>

        </tr>

        <!-- INCS01 -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN BERGAJI</strong></td>

          <td><strong>INCS01</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS01}}
          </td>

          <td style="text-align:center;" >{{totalINCS01}}</td>
        </tr>
        
        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 green lighten-3"><strong>PENDAPATAN BEKERJA SENDIRI</strong></th>
        </tr>
        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2"><strong>Pertanian dan Perikanan</strong></th>
        </tr>
                          <!-- -----------------------HK2&HK3-------------------------------------- -->
        <!-- INCS21A(i) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi e-dagang</td>

          <td>INCS21A(i)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">

            <!-- //sepatutnya buat function kira// -->
          {{Number(item.HK2INCS21A_i) + Number(item.HK3INCS21A_i)}}
          </td>

          <td style="text-align:center;" >{{totalHK2INCS21A_i}}</td>

        </tr>

        <!-- INCS21A(ii) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi bukan e-dagang</td>

          <td>INCS21A(ii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">

          <!-- //sepatutnya buat function kira// -->
          {{Number(item.HK2INCS21A_ii) + Number(item.HK3INCS21A_ii)}}
          </td>

          <td style="text-align:center;" >{{totalHK2INCS21A_ii}}</td>

        </tr>

        <!-- INCS21A(iii) -->
        <tr>
          <td>Pendapatan bukan dalam talian</td>

          <td>INCS21A(iii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">

          <!-- //sepatutnya buat function kira// -->
          {{Number(item.HK2INCS21A_iii) + Number(item.HK3INCS21A_iii)}}
          </td>

          <td style="text-align:center;" >{{totalHK2INCS21A_iii}}</td>
          

        </tr>

        <!-- INCS21A -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN PERTANIAN & PERIKANAN</strong></td>

          <td><strong>INCS21A</strong></td>

            <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{kiraINCS21A(item)}}

          </td>
          

          <td style="text-align:center;" >{{totalHK2INCS21A}}</td>
        </tr>

        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2"><strong>ICT</strong></th>
        </tr>

                                                  <!-- INCS21 HK -->

        <!-- INCS21b(i) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi e-dagang</td>

          <td>INCS21b(i)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK4INCS21B_i}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21B_i}}</td>

        </tr>

        <!-- INCS21b(ii) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi bukan e-dagang</td>

          <td>INCS21b(ii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK4INCS21B_ii}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21B_ii}}</td>

        </tr>

        <!-- INCS21b(iii) -->
        <tr>
          <td>Pendapatan bukan dalam talian</td>

          <td>INCS21b(iii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK4INCS21B_iii}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21B_iii}}</td>

        </tr>

        <!-- INCS21b -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN ICT</strong></td>

          <td><strong>INCS21b</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK4INCS21b}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21b}}</td>
        </tr>

        <!-- INCS21c -->
        <tr>
          <td><strong>KOMISEN DARIPADA AKTIVITI ICT</strong></td>

          <td><strong>INCS21c</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK4INCS21c}}
          </td>

          <td style="text-align:center;" >{{totalHK4INCS21c}}</td>
        </tr>

      <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Pengangkutan</th>
        </tr>

        <!-- INCS21d(i) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi e-dagang</td>

          <td>INCS21d(i)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK5INCS21D_i}}
          </td>

          <td style="text-align:center;" >{{totalHK5INCS21D_i}}</td>

        </tr>

        <!-- INCS21d(ii) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi bukan e-dagang</td>

          <td>INCS21d(ii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK5INCS21D_ii}}
          </td>

          <td style="text-align:center;" >{{totalHK5INCS21D_ii}}</td>

        </tr>

        <!-- INCS21d(iii) -->
        <tr>
          <td>Pendapatan bukan dalam talian</td>

          <td>INCS21d(iii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK5INCS21D_iii}}
          </td>

          <td style="text-align:center;" >{{totalHK5INCS21D_iii}}</td>

        </tr>

        <!-- INCS21d -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN PENGANGKUTAN</strong></td>

          <td><strong>INCS21d</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK5INCS21d}}
          </td>

          <td style="text-align:center;" >{{totalHK5INCS21d}}</td>
        </tr>

         <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Lain-lain</th>
        </tr>

        <!-- INCS21e(i) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi e-dagang</td>

          <td>INCS21e(i)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK6INCS21E_i}}
          </td>

          <td style="text-align:center;" >{{totalHK6INCS21E_i}}</td>

        </tr>

        <!-- INCS21e(ii) -->
        <tr>
          <td>Pendapatan dalam talian melalui transaksi bukan e-dagang</td>

          <td>INCS21e(ii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK6INCS21E_ii}}
          </td>

          <td style="text-align:center;" >{{totalHK6INCS21E_ii}}</td>

        </tr>

        <!-- INCS21e(iii) -->
        <tr>
          <td>Pendapatan bukan dalam talian</td>

          <td>INCS21e(iii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK6INCS21E_iii}}
          </td>

          <td style="text-align:center;" >{{totalHK6INCS21E_iii}}</td>

        </tr>

        <!-- INCS21e -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN LAIN-LAIN</strong></td>

          <td><strong>INCS21e</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.HK6INCS21e}}
          </td>

          <td style="text-align:center;" >{{totalHK6INCS21e}}</td>
        </tr>

        <!-- INCS21NA -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN BUKAN PERTANIAN & PERIKANAN</strong></td>

          <td><strong>INCS21NA</strong></td>

          <!-- <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS21NA}}
          </td> -->

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            <!-- {{item.NOAIR}} : {{item.INCS21}} -->
            {{kiraINCS21NA(item)}}

          </td>

          <td style="text-align:center;" >{{totalINCS21NA}}</td>
        </tr>

        <!-- INCS21KS -->
        <tr>
          <td><strong>JUMLAH KEGUNAAN SENDIRI</strong></td>

          <td><strong>INCS21KS</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS21KS}}
          </td>

          <td style="text-align:center;" >{{totalINCS21KS}}</td>
        </tr>

        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Pendapatan Bekerja Sendiri</th>
        </tr>

        
        <!-- INCS21 -->
         <tr>
          <td><strong>JUMLAH PENDAPATAN BEKERJA SENDIRI</strong></td>

          <td><strong>INCS21</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            <!-- {{item.NOAIR}} : {{item.INCS21}} -->
            {{kiraINCS21(item)}}

          </td>

          <td style="text-align:center;" >{{totalINCS21}}</td>
        </tr>

        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Pendapatan Harta yang Disewakan</th>
        </tr>

        <!-- INCS22 -->
        <tr>
          <td>Sewa dinilai bagi rumah yang diduduki oleh pemiliknya</td>

          <td>INCS22</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS22}}
          </td>

          <td style="text-align:center;" >{{totalINCS22}}</td>

        </tr>

        <!-- INCS23 -->
        <tr>
          <td>Rumah/Harta lain yang disewakan</td>

          <td>INCS23</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS23}}
          </td>

          <td style="text-align:center;" >{{totalINCS23}}</td>

        </tr>

        <!-- INCS24 -->
        <tr>
          <td>Sewa daripada tempat menginap</td>

          <td>INCS24</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS24}}
          </td>

          <td style="text-align:center;" >{{totalINCS24}}</td>

        </tr>

        <!-- INCS02 -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN LAIN DIPEROLEH</strong></td>

          <td><strong>INCS02</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{kiraINCS02(item)}}

          </td>

          <td style="text-align:center;" >{{totalINCS02}}</td>
        </tr>

        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Pendapatan Harta</th>
        </tr>

        <!-- INC31 -->
        <tr>
          <td>Royalti</td>

          <td>INCS31</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS31}}
          </td>

          <td style="text-align:center;" >{{totalINCS31}}</td>

        </tr>

        <!-- INCS32a -->
        <tr>
          <td>Sewa tanah pertanian</td>

          <td>INCS32a</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS32a}}
          </td>

          <td style="text-align:center;" >{{totalINCS32a}}</td>

        </tr>

         <!-- INCS32b -->
        <tr>
          <td>Sewa tanah bukan pertanian</td>

          <td>INCS32b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS32b}}
          </td>

          <td style="text-align:center;" >{{totalINCS32b}}</td>

        </tr>

        <!-- INCS32 -->
        <tr>
          <td><strong>JUMLAH SEWAAN TANAH</strong></td>

          <td><strong>INCS32</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS32}}
          </td>

          <td style="text-align:center;" >{{totalINCS32}}</td>
        </tr>

        <!-- INCS33 -->
        <tr>
          <td>Faedah</td>

          <td>INCS33</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS33}}
          </td>

          <td style="text-align:center;" >{{totalINCS33}}</td>

        </tr>

        <!-- INCS34 -->
        <tr>
          <td>Dividen</td>

          <td>INCS34</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS34}}
          </td>

          <td style="text-align:center;" >{{totalINCS34}}</td>

        </tr>

        <!-- INCS03 -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN DARIPADA HARTA</strong></td>

          <td><strong>INCS03</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
           
            {{kiraINCS03(item)}}
          </td>
        
          <td style="text-align:center;" >{{totalINCS03}}</td>
        </tr>

        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Pendapatan Pindahan Semasa Diterima</th>
        </tr>

        <!-- INCS41a -->
        <tr>
          <td>Kiriman wang yang diterima daripada isi rumah yang lain dalam negara</td>

          <td>INCS41a</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS41a}}
          </td>

          <td style="text-align:center;" >{{totalINCS41a}}</td>

        </tr>

        <!-- INCS41b -->
        <tr>
          <td>Kiriman wang yang diterima daripada isi rumah yang lain luar negara</td>

          <td>INCS41b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS41b}}
          </td>

          <td style="text-align:center;" >{{totalINCS41b}}</td>

        </tr>

        <!-- INCS41 -->
        <tr>
          <td><strong>JUMLAH KIRIMAN WANG YANG DITERIMA DARIPADA ISI RUMAH YANG LAIN</strong></td>

          <td><strong>INCS41</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS41}}
          </td>

          <td style="text-align:center;" >{{totalINCS41}}</td>
        </tr>

        <!-- INCS42 -->
        <tr>
          <td>Nafkah</td>

          <td>INCS42</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS42}}
          </td>

          <td style="text-align:center;" >{{totalINCS42}}</td>

        </tr>

        <!-- INCS43 -->
        <tr>
          <td>Biasiswa/Dermasiswa/Fellowships</td>

          <td>INCS43</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS43}}
          </td>

          <td style="text-align:center;" >{{totalINCS43}}</td>
        </tr> 
        <!-- INCS44 -->
        <tr>
          <td>Pencen</td>

          <td>INCS44</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS44}}
          </td>

          <td style="text-align:center;" >{{totalINCS44}}</td>
        </tr> 

        <!-- INCS45a -->
        <tr>
          <td>Elaun yang diterima oleh kerabat diraja</td>

          <td>INCS45a</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45a}}
          </td>

          <td style="text-align:center;" >{{totalINCS45a}}</td>
        </tr> 

         <!-- INCS45b -->
        <tr>
          <td>Bantuan diterima secara bulanan daripada Jab. Kebajikan Masyarakat  dan/atau agensi kerajaan lain secara berkala</td>

          <td>INCS45b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45b}}
          </td>

          <td style="text-align:center;" >{{totalINCS45b}}</td>
        </tr> 

         <!-- INCS45c -->
        <tr>
          <td>Penerimaan wang secara berkala daripada harta pusaka atau tabung wang amanah</td>

          <td>INCS45c</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45c}}
          </td>

          <td style="text-align:center;" >{{totalINCS45c}}</td>
        </tr> 

         <!-- INCS45d -->
        <tr>
          <td>Pembayaran insurans diterima secara berkala disebabkan oleh kecederaan</td>

          <td>INCS45d</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45d}}
          </td>

          <td style="text-align:center;" >{{totalINCS45d}}</td>
        </tr> 

        <!-- INCS45e -->
        <tr>
          <td>Pampasan diberikan oleh majikan kepada pekerja disebabkan kecacatan akibat kemalangan semasa bekerja. Pembayaran diberi secara berkala setiap bulan berbentuk wang tunai</td>

          <td>INCS45e</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45e}}
          </td>

          <td style="text-align:center;" >{{totalINCS45e}}</td>
        </tr> 

        <!-- INCS45f -->
        <tr>
          <td>Elaun yang diterima oleh imam, bilal dan siak yang dibayar bawah peruntukan masjid</td>

          <td>INCS45f</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45f}}
          </td>

          <td style="text-align:center;" >{{totalINCS45f}}</td>
        </tr> 

         <!-- INCS45g -->
        <tr>
          <td>Elaun yang diterima oleh sami/paderi yang dibayar oleh rumah ibadat</td>

          <td>INCS45g</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45g}}
          </td>

          <td style="text-align:center;" >{{totalINCS45g}}</td>
        </tr> 

         <!-- INCS45h -->
        <tr>
          <td>Elaun bulanan ahli sukan (bukan profesional) yang diterima daripada Majlis Sukan Negara Malaysia</td>

          <td>INCS45h</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45h}}
          </td>

          <td style="text-align:center;" >{{totalINCS45h}}</td>
        </tr> 

           <!-- INCS45i -->
        <tr>
          <td>Lain-lain elaun</td>

          <td>INCS45i</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45i}}
          </td>

          <td style="text-align:center;" >{{totalINCS45i}}</td>
        </tr> 

         <!-- INCS45j -->
        <tr>
          <td>Bantuan Sara Hidup (BSH)/ Bantuan Prihatin Rakyat (BPR)</td>

          <td>INCS45j</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45j}}
          </td>

          <td style="text-align:center;" >{{totalINCS45j}}</td>
        </tr> 

        <!-- INCS45k -->
        <tr>
          <td>Bantuan persekolahan </td>

          <td>INCS45k</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45k}}
          </td>

          <td style="text-align:center;" >{{totalINCS45k}}</td>
        </tr> 

        <!-- INCS45l -->
        <tr>
          <td>Sumbangan Asas Rahmah (SARA) </td>

          <td>INCS45l</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45l}}
          </td>

          <td style="text-align:center;" >{{totalINCS45l}}</td>
        </tr> 

          <!-- INCS45m -->
          <tr>
          <td>Penerimaan zakat secara berkala daripada Majlis Agama Islam Negeri </td>

          <td>INCS45m</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45m}}
          </td>

          <td style="text-align:center;" >{{totalINCS45m}}</td>
        </tr> 

        <!-- INCS45 -->
        <tr>
          <td><strong>JUMLAH PEMBAYARAN LAIN BERKALA YANG DITERIMA</strong></td>

          <td><strong>INCS45</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS45}}
          </td>

          <td style="text-align:center;" >{{totalINCS45}}</td>
        </tr> 

        <!-- INCS46a(i) -->
        <tr>
          <td>Hadiah berupa wang tunai daripada kerajaan persekutuan</td>

          <td>INCS46a(i)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46a_i}}
          </td>

          <td style="text-align:center;" >{{totalINCS46a_i}}</td>
        </tr>

        <!-- INCS46a(ii) -->
        <tr>
          <td>Hadiah berupa wang tunai daripada kerajaan negeri</td>

          <td>INCS46a(ii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46a_ii}}
          </td>

          <td style="text-align:center;" >{{totalINCS46a_ii}}</td>
        </tr>

        <!-- INCS46a -->
        <tr>
          <td><strong>JUMLAH HADIAH BERUPA WANG TUNAI DARIPADA KERAJAAN</strong></td>

          <td><strong>INCS46a</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46a}}
          </td>

          <td style="text-align:center;" >{{totalINCS46a}}</td>
        </tr>

        <!-- INCS46b -->
        <tr>
          <td>Hadiah berupa wang tunai daripada NGO/ swasta</td>

          <td>INCS46b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46b}}
          </td>

          <td style="text-align:center;" >{{totalINCS46b}}</td>
        </tr>

         <!-- INCS46c -->
        <tr>
          <td>Hadiah berupa wang tunai daripada individu</td>

          <td>INCS46c</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46c}}
          </td>

          <td style="text-align:center;" >{{totalINCS46c}}</td>
        </tr>

        <!-- INCS46d(i) -->
        <tr>
          <td>Hadiah berupa mata benda daripada kerajaan persekutuan</td>

          <td>INCS46d(i)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46d_i}}
          </td>

          <td style="text-align:center;" >{{totalINCS46d_i}}</td>
        </tr>

         <!-- INCS46d(ii) -->
        <tr>
          <td>Hadiah berupa mata benda daripada kerajaan negeri</td>

          <td>INCS46d(ii)</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46d_ii}}
          </td>

          <td style="text-align:center;" >{{totalINCS46d_ii}}</td>
        </tr>

        <!-- INCS46d -->
        <tr>
          <td><strong>JUMLAH HADIAH BERUPA MATA BENDA DARIPADA KERAJAAN</strong></td>

          <td><strong>INCS46d</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46d}}
          </td>

          <td style="text-align:center;" >{{totalINCS46d}}</td>
        </tr>

        <!-- INCS46e -->
        <tr>
          <td>Hadiah berupa mata benda daripada NGO/ swasta</td>

          <td>INCS46e</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46e}}
          </td>

          <td style="text-align:center;" >{{totalINCS46e}}</td>
        </tr>

        <!-- INCS46f -->
        <tr>
          <td>Hadiah berupa mata benda daripada individu</td>

          <td>INCS46f</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46f}}
          </td>

          <td style="text-align:center;" >{{totalINCS46f}}</td>
        </tr>

        <!-- INCS46 -->
        <tr>
          <td><strong>JUMLAH HADIAH BERUPA WANG TUNAI/ MATA BENDA </strong></td>

          <td><strong>INCS46</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS46}}
          </td>

          <td style="text-align:center;" >{{totalINCS46}}</td>
        </tr>

        <!-- INCS05 -->
        <tr>
          <td><strong>JUMLAH PINDAHAN SEMASA YANG DITERIMA </strong></td>

          <td><strong>INCS05</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            
            {{kiraINCS05(item)}}
          </td>

          <td style="text-align:center;" >{{totalINCS05}}</td>
        </tr>

         <!-- TP73 -->
        <tr>
          <td><strong>JUMLAH BAYARAN PINDAHAN SEMASA  </strong></td>

          <td><strong>TP73</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.TP73}}
          </td>

          <td style="text-align:center;" >{{totalTP73}}</td>
        </tr>

          <!-- INCS06 -->
        <tr>
          <td><strong>JUMLAH PINDAHAN SEMASA BERSIH YANG DITERIMA </strong></td>

          <td><strong>INCS06</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
           
            {{kiraINCS06(item)}}
          </td>

          <td style="text-align:center;" >{{totalINCS06}}</td>
        </tr>

        <!-- INCS07 -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN KASAR </strong></td>

          <td><strong>INCS07</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            
            {{kiraINCS07(item)}}
          </td>

          <td style="text-align:center;" >{{totalINCS07}}</td>
        </tr>

         <!-- INCS08 -->
        <tr>
          <td><strong>JUMLAH PENDAPATAN BERSIH </strong></td>

          <td><strong>INCS08</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
          
            {{kiraINCS08(item)}}
          </td>

          <td style="text-align:center;" >{{totalINCS08}}</td>
        </tr>



        <tr>
              <th colspan="10" style="text-align:center;" class="text-h6 grey lighten-2">Penerimaan Bantuan <label class="font-italic"> One-Off</label></th>
        </tr>

          <!-- INCS10a -->
        <tr>
          <td>Nilai penerimaan pusaka </td>

          <td>INCS10a</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_a}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_a}}</td>
        </tr>

        <!-- INCS10b -->
        <tr>
          <td>Nilai penerimaan hadiah/loteri </td>

          <td>INCS10b</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_b}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_b}}</td>
        </tr>

        <!-- INCS10c -->
        <tr>
          <td>Nilai penerimaan pampasan </td>

          <td>INCS10c</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_c}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_c}}</td>
        </tr>

         <!-- INCS10d -->
        <tr>
          <td>Nilai penerimaan ganjaran </td>

          <td>INCS10d</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_d}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_d}}</td>
        </tr>

        <!-- INCS10e -->
        <tr>
          <td>Nilai penerimaan derma/sumbangan dari individu/NGO  </td>

          <td>INCS10e</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_e}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_e}}</td>
        </tr>

        <!-- INCS10f -->
        <tr>
          <td>Nilai penerimaan pinjaman </td>

          <td>INCS10f</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_f}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_f}}</td>
        </tr>

        <!-- INCS10g -->
        <tr>
          <td>Nilai penerimaan jualan aset  </td>

          <td>INCS10g</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_g}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_g}}</td>
        </tr>

        <!-- INCS10h -->
        <tr>
          <td>Nilai penerimaan lain-lain </td>

          <td>INCS10h</td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
            {{item.INCS10_h}}
          </td>

          <td style="text-align:center;" >{{totalINCS10_h}}</td>
        </tr>


         <!-- INCS10 -->
        <tr>
          <td><strong>JUMLAH PENERIMAAN BANTUAN <label class="font-italic">ONE-OFF</label></strong></td>

          <td><strong>INCS10</strong></td>

          <td v-for="item in summaryData.dataJR5" :key="item.NOAIR" class="text-center">
           {{item.INCS10}}
          </td>

          <td style="text-align:center;" >{{totalINCS10}}</td>
        </tr>

      </tbody>
    </v-simple-table>





  </v-card-text>
</v-card>

<v-card class="mt-2">
  <v-card-text>
    <v-simple-table>
        <thead >
            <tr>
              <th colspan="30" >
                Punca Pendapatan
              </th>

              <th >
                Kod INCS
              </th>

              <th v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR" >
                {{item.NOAIR}}
              </th>
            
              <th v-for="item in summaryData.dataPER9" :key="item.NOAIR" >
                {{item.NOAIR}}
              </th>

              <th>
                Jumlah Pendapatan Isi Rumah
              </th>  
            </tr>
          </thead>

          <tbody>
            <tr>
                  <th colspan="40" style="text-align:center;" class="text-h6 grey lighten-2">Pendapatan Bulan Sebelumnya</th>
            </tr>

              <!-- INCS9a -->
            <tr v-if="S==1">
              <td colspan="30" >Wang yang dikeluarkan daripada simpanan terdahulu</td>

              <td>INCS9a</td>

              <td  v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR">
                {{item.JUM9a}}
              </td>

              <td>{{totalINCS9a}}</td>
            </tr>

            <tr v-if="S==2">
              <td colspan="30" >Wang yang dikeluarkan daripada simpanan terdahulu</td>

              <td>INCS9a</td>

              <td  v-for="item in summaryData.dataPER9" :key="item.NOAIR">
                {{item.JUM9a}}
              </td>

              <td>{{totalINCS9a}}</td>
            </tr>

            <!-- INCS9b -->
            <tr v-if="S==1">
              <td colspan="30" >Jualan bon, saham dan jaminan</td>

              <td>INCS9b</td>

              <td  v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR">
                {{item.JUM9b}}
              </td>

              <td>{{totalINCS9b}}</td>
            </tr>

            <tr v-if="S==2">
              <td colspan="30" >Jualan bon, saham dan jaminan</td>

              <td>INCS9b</td>

              <td  v-for="item in summaryData.dataPER9" :key="item.NOAIR">
                {{item.JUM9b}}
              </td>

              <td>{{totalINCS9b}}</td>
            </tr>

            <!-- INCS9c -->
            <tr v-if="S==1">
              <td colspan="30" >Pinjaman dari bank, koperasi dan orang perseorangan</td>

              <td>INCS9c</td>

              <td  v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR">
                {{item.JUM9c}}
              </td>

              <td>{{totalINCS9c}}</td>
            </tr>

            <tr v-if="S==2">
              <td colspan="30" >Pinjaman dari bank, koperasi dan orang perseorangan</td>

              <td>INCS9c</td>

              <td  v-for="item in summaryData.dataPER9" :key="item.NOAIR">
                {{item.JUM9c}}
              </td>

              <td>{{totalINCS9c}}</td>
            </tr>

            <!-- INCS9d -->
            <tr v-if="S==1">
              <td colspan="30" >Sewa beli - pinjaman yang diperoleh</td>

              <td>INCS9d</td>

              <td  v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR">
                {{item.JUM9d}}
              </td>

              <td>{{totalINCS9d}}</td>
            </tr>

            <tr v-if="S==2">
              <td colspan="30" >Sewa beli - pinjaman yang diperoleh</td>

              <td>INCS9d</td>

              <td  v-for="item in summaryData.dataPER9" :key="item.NOAIR">
                {{item.JUM9d}}
              </td>

              <td>{{totalINCS9d}}</td>
            </tr>

            <!-- INCS9e -->
            <tr v-if="S==1">
              <td colspan="30" >Penerimaan lain</td>

              <td>INCS9e</td>

              <td  v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR">
                {{item.JUM9e}}
              </td>

              <td>{{totalINCS9e}}</td>
            </tr>

            <tr v-if="S==2">
              <td colspan="30" >Penerimaan lain</td>

              <td>INCS9e</td>

              <td  v-for="item in summaryData.dataPER9" :key="item.NOAIR">
                {{item.JUM9e}}
              </td>

              <td>{{totalINCS9e}}</td>
            </tr>

            <!-- INCS09 -->
            <tr v-if="S==1">
              <td colspan="30" ><strong>JUMLAH PENERIMAAN LAIN DALAM BULAN SEBELUMNYA </strong></td>

              <td><strong>INCS09</strong></td>

              <td v-for="item in summaryData.dataBLK_VII_IMBANG" :key="item.NOAIR">
              
                {{kiraINCS09(item)}}
              </td>

              <td>{{totalINCS09}}</td>
            </tr>

            <tr v-if="S==2">
              <td colspan="30" >JUMLAH PENERIMAAN LAIN DALAM BULAN SEBELUMNYA</td>

              <td>INCS09</td>

              <td  v-for="item in summaryData.dataPER9" :key="item.NOAIR">
                <!-- {{item.INCS09}} -->
                {{kiraINCS09(item)}}
              </td>

              <td>{{totalINCS09}}</td>
            </tr>

            </tbody>
    </v-simple-table>
  </v-card-text>
</v-card>


  <v-dialog v-model="showBorangPengesahan" max-width="1000" persistent>
      <v-card>
        <v-card-title class="text-h5">
        PAUTAN KE IMBANGAN
        </v-card-title>

        <v-card-text>

          <v-row> 
            <v-col cols="6">
            Jumlah Pendapatan Bekerja Sendiri (Bukan Pertanian) <strong> [INCS21NA] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS21NA"
                disabled
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="6">
            Jumlah Pendapatan Pekerjaan Sendiri <strong> [INCS21] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS21"
                disabled
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="6">
            Jumlah Pendapatan Lain Diperoleh <strong> [INCS02] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS02"
                disabled
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="6">
            Jumlah Pendapatan Daripada Harta <strong> [INCS03] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS03"
                disabled
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="6">
            Jumlah Pindahan Semasa Bersih Yang Diterima <strong>  [INCS06] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS06"
                disabled
                readonly
              ></v-text-field>
            </v-col>

             <v-col cols="6">
            Jumlah Kasar <strong> [INCS07] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS07"
                disabled
                readonly
              ></v-text-field>
            </v-col>

             <v-col cols="6">
            Jumlah Kasar <strong> [INCS08] </strong>
            </v-col>
           <v-col cols="2">
              
              <v-text-field
                outlined
                dense
                v-model="totalINCS08"
                disabled
                readonly
              ></v-text-field>
            </v-col>
            </v-row>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

            <v-btn color="error" @click="showBorangPengesahan = false"> BATAL </v-btn>

            <v-btn color="success" @click="dialogPengesahan = true;"> DISAHKAN & SIMPAN </v-btn>

        </v-card-actions>

      </v-card>
    </v-dialog>


  <!-- DIalog Pengesahan -->
  <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         {{$t("Adakah anda pasti untuk mengesahkan?")}}<br><br>
         <strong>{{$t(" HID: "+this.HID)}}</strong>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="success"
            @click="simpan()"
          >
            {{$t('sah')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>


  <v-dialog
        v-model="errorDialog"
        width="500"
        height="200"
      >
      <v-card>
        <v-alert
          dense
          outlined
          color="#C51162"
          type="error"
        >
        <strong>{{errMessage}}</strong>
        </v-alert>
      </v-card>
  </v-dialog>
  
  <!-- Success Dialog -->
  <v-dialog
        v-model="successDialog"
        max-width="800"
        height="200"
      >
      <v-card
        color="success"
      >
        <v-alert
          dense
          outlined
          color="#C51162"
          type="success"
        >
        <strong>{{successMessage}}</strong>
        </v-alert>
      </v-card>
  </v-dialog>


</v-card>
</div>
</template>

<script>
// @ is an alias to /src
import axios from '../../plugins/axios'
//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import maklumatIsiRumah from '@/services/ringkasanMaklumatIsiRumah'
const servicesMaklumatIsiRumah = new maklumatIsiRumah();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();


export default {

  // components: {
  //   PieChart
  // },
  async beforeMount(){
    this.userData = localStorageData.user();
    var dataHID = localStorageData.getHIDdata()
 
    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB =  dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.KAW = dataHID.KAW;
    this.BULAN = dataHID.BULAN;
    this.TAHUN = dataHID.TAHUN;
    this.statusHID = dataHID.statusHID;
   
    this.summaryData = await servicesMaklumatIsiRumah.getMaklumatIsiRumahByHID(this.HID);
    // console.log(this.summaryData.dataJR5.length)
    // console.log(this.summaryData.dataBLK_VII_IMBANG.length)
    // console.log(this.summaryData.dataJRE.length)
    // console.log(this.summaryData.dataPB.length)
    // console.log(this.summaryData.dataPER9.length)
    
    //console.log(this.summaryData)

  },
  data: () => ({
    successDialog: false,
    errorDialog: false,

    successMessage:'',
    errMessage:'',
    summaryData:[],
    publicHIDdata:[],
    showBorangPengesahan : false,
    dialogPengesahan: false,
    status: 0,
    statusHID: 0
  }),
  methods:{
    kiraINCS02(data){ 
      var total = 0
        total = Number(total) + Number(data.HK2INCS21a) + Number(data.HK3INCS21a) + Number(data.HK4INCS21b) + Number(data.HK4INCS21c) + Number(data.HK5INCS21d) + Number(data.HK6INCS21e) + Number(data.INCS21KS) + Number(data.INCS22) + Number(data.INCS23) + Number(data.INCS24)
        data.INCS02 = total;
        return total;
    },
    kiraINCS03(data){ 
      var total = 0
         total = Number(total) + Number(data.INCS31) + Number(data.INCS32) + Number(data.INCS33) + Number(data.INCS34)
         data.INCS03 = total;
        return total;
    },
    kiraINCS05(data){ 
      var total = 0
         total =  Number(data.INCS41) + Number(data.INCS42)+ Number(data.INCS43) + Number(data.INCS44) + Number(data.INCS45) + Number(data.INCS46) 
        return total;
    },
    kiraINCS06(data){ 
      var total = 0
        total = Number(total) + (Number(data.INCS41) + Number(data.INCS42)+ Number(data.INCS43) + Number(data.INCS44) + Number(data.INCS45) + Number(data.INCS46)) - Number(data.TP73)
        data.INCS06 = total;
        return total;
    },
    kiraINCS07(data){ 
      var total = 0
        total = Number(total) + Number(data.INCS01) + Number(data.HK2INCS21a) + Number(data.HK3INCS21a) + Number(data.HK4INCS21b) + Number(data.HK4INCS21c) + Number(data.HK5INCS21d) + Number(data.HK6INCS21e) + Number(data.INCS21KS) + Number(data.INCS22) + Number(data.INCS23) + Number(data.INCS24) + Number(data.INCS31) + Number(data.INCS32) + Number(data.INCS33) + Number(data.INCS34) + Number(data.INCS41) + Number(data.INCS42)+ Number(data.INCS43) + Number(data.INCS44) + Number(data.INCS45) + Number(data.INCS46) 
        data.INCS07 = total;
        return total.toFixed(2);
    },
    kiraINCS08(data){ 
      var total = 0
        total = Number(total) + Number(data.INCS01) + Number(data.HK2INCS21a) + Number(data.HK3INCS21a) + Number(data.HK4INCS21b) + Number(data.HK4INCS21c) + Number(data.HK5INCS21d) + Number(data.HK6INCS21e) + Number(data.INCS21KS) + Number(data.INCS22) + Number(data.INCS23) + Number(data.INCS24) + Number(data.INCS31) + Number(data.INCS32) + Number(data.INCS33) + Number(data.INCS34) + ((Number(data.INCS41) + Number(data.INCS42)+ Number(data.INCS43) + Number(data.INCS44) + Number(data.INCS45) + Number(data.INCS46))- Number(data.TP73))
        data.INCS08 = total;
        return total.toFixed(2);
    },
    kiraINCS09(data){ 
      var total = 0
            total = Number(total) + Number(data.JUM9a) + Number(data.JUM9b) + Number(data.JUM9c) + Number(data.JUM9d) + Number(data.JUM9e) 
        return total;
    },
    kiraINCS21A(data){ 
      var total = 0
      total = Number(total) + Number(data.HK2INCS21a) + Number(data.HK3INCS21a) 
      // total = Number(total) + Number(data.HK2INCS21A_i) + Number(data.HK3INCS21A_i) + Number(data.HK2INCS21A_ii) + Number(data.HK3INCS21A_ii) + + Number(data.HK2INCS21A_iii) + Number(data.HK3INCS21A_ii)
      data.INCS21A = total;
      return total;
    },
    kiraINCS21(data){ 
      
      var total = 0
          //total = Number(total) + Number(data.HK2INCS21a) + Number(data.INCS21NA) + Number(data.INCS21KS)
          total = Number(total) + Number(data.HK2INCS21a) + Number(data.HK3INCS21a) + Number(data.HK4INCS21b) + Number(data.HK4INCS21c) + Number(data.HK5INCS21d) + Number(data.HK6INCS21e) + Number(data.INCS21KS) 
          data.INCS21 = total;
        return total;
    },    
    kiraINCS21NA(data){ 
      
      var total = 0
        //total = Number(total) + Number(data.HK2INCS21a) + Number(data.INCS21NA) + Number(data.INCS21KS)
        total = Number(total) + Number(data.HK4INCS21b) + Number(data.HK4INCS21c) + Number(data.HK5INCS21d) + Number(data.HK6INCS21e) 
        data.INCS21NA = total;
        return total;
    },   

    kiraINCS10(data){ 
      var total = 0
            total = Number(total) + Number(data.INCS10_a) + Number(data.INCS10_b) + Number(data.INCS10_c) + Number(data.INCS10_d) + Number(data.INCS10_e) + Number(data.INCS10_f)
            + Number(data.INCS10_g) + Number(data.INCS10_h)
        return total;
    },
  

    butangPengesahan(){
      if(this.S == 1){
        this.showBorangPengesahan=true;
      }
      if(this.S == 2){
        let dataz = {
          INCS21NA : this.totalINCS21NA,
          INCS21 : this.totalINCS21,
          INCS01 : this.totalINCS01,
          INCS02 : this.totalINCS02,
          INCS03 : this.totalINCS03,
          INCS05 : this.totalINCS05,
          INCS06 : this.totalINCS06,
          INCS07 : this.totalINCS07,
          INCS08 : this.totalINCS08,
          INCS09 : this.totalINCS09,
          INCS10 : this.totalINCS10,
          totalTP73 : this.totalTP73
        
        };
        this.$router.push({name: "JR2Imbangan",params: { dataz }});
      }
    },
    async simpan(){

      if(this.S == 1){
        this.status = 2;
      }
      if(this.S == 2){
        this.status = 4;
        //this.$router.push({name: "JR2Imbangan"});
      }

      try{

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/pengesahan/updateHID`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                totalINCS21NA : this. totalINCS21NA,
                totalINCS21 : this.totalINCS21,
                totalINCS02 : this.totalINCS02,
                totalINCS03 : this.totalINCS03,
                totalINCS06 : this.totalINCS06,
                totalINCS07 : this.totalINCS07,
                totalINCS08 : this.totalINCS08,
                totalTP73 : this.totalTP73,
                Sample: this.S,
                statusHID: this.status
              })
                //var res = res.data.data;
                //console.log(res)
                this.showBorangPengesahan  = false;
                this.dialogPengesahan = false;
                var dataz = await publicServices.getBorangByHID(this.HID);//dapatkan data HID
                this.publicHIDdata = dataz.data.data;
                var setHIDtoLocalStorage = localStorageData.setHID(this.publicHIDdata);//setkan data HID ke dalam local storage
                window.location.reload();
                // this.successMessage = 'Data Disimpan!';
                // this.successDialog = true;
                // window.scrollTo(0, 0);
                
            } catch (error) {
              console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
      },

      async pengesahanDataAir(data){
        console.log(data)
        try{

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/pengesahan/updateINCS`, {
                HID:  data.HID,
                NOAIR: data.NOAIR,
                INCS01 : data.INCS01,
                INCS02 : data.INCS02,
                INCS03 : data.INCS03,
                INCS05 : data.INCS05,
                INCS06 : data.INCS06,
                INCS07 : data.INCS07,
                INCS08 : data.INCS08,
                INCS21A : data.INCS21A,
                INCS21 : data.INCS21,
                INCS21NA : data.INCS21NA
              })

              //console.log(res)
              if(res.data.status){
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 3000);
                //this.successDialog = true;

              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 3000);
                this.errMessage = 'RALAT MENYIMPAN DATA!';
              }
                
                
            } catch (error) {
              console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
      
      }

  
  
  
  },
  computed:{
    totalINCS11: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS11)
      }
      // return total;
      return total;
    },
     totalINCS12: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS12)
      }
      return total;
      // return total;
    },
     totalINCS13: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS13)
      }
      return total;
    },
     totalINCS14: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS14)
      }
      return total;
    },
     totalINCS15: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS15)
      }
      return total;
    },
     totalINCS16: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS16)
      }
      return total;
    },
     totalINCS17: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS17)
      }
      return total;
    },
     totalINCS18: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS18)
      }
      return total;
    },
    totalINCS19_a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS19_a)
      }
      return total;
    },
     totalINCS19_b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS19_b)
      }
      return total;
    },
     totalINCS19_c: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS19_c)
      }
      return total;
    },
     totalINCS19: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS19)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS19_a) + Number(this.summaryData.dataJR5[i].INCS19_b) + Number(this.summaryData.dataJR5[i].INCS19_c)
      }
      return total;
    },
    totalINCS01: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS01)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS11) + Number(this.summaryData.dataJR5[i].INCS12) + Number(this.summaryData.dataJR5[i].INCS13) + Number(this.summaryData.dataJR5[i].INCS14) + Number(this.summaryData.dataJR5[i].INCS15) + Number(this.summaryData.dataJR5[i].INCS16) + Number(this.summaryData.dataJR5[i].INCS17) + Number(this.summaryData.dataJR5[i].INCS18) + Number(this.summaryData.dataJR5[i].INCS19)       
      }
      return total.toFixed(2);
    },
     totalHK2INCS21A_i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK2INCS21A_i) + Number(this.summaryData.dataJR5[i].HK3INCS21A_i)
      }
      
      return total;
    },
     totalHK2INCS21A_ii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK2INCS21A_ii) + Number(this.summaryData.dataJR5[i].HK3INCS21A_ii)
      }
      return total;
    },
      totalHK2INCS21A_iii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK2INCS21A_iii) + Number(this.summaryData.dataJR5[i].HK3INCS21A_iii)
      }
      return total;
    },
      totalHK2INCS21A: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK2INCS21a) + Number(this.summaryData.dataJR5[i].HK3INCS21a)

        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS21A_i) + Number(this.summaryData.dataJR5[i].INCS21A_ii) + Number(this.summaryData.dataJR5[i].INCS21A_iii) 
      }
      return total;
    },
      totalHK4INCS21B_i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21B_i)
      }
      return total;
    },
     totalHK4INCS21B_ii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21B_ii)
      }
      return total;
    },
      totalHK4INCS21B_iii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21B_iii)
      }
      return total;
    },
      totalHK4INCS21b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21b)
      }
      return total;
    },
      totalHK4INCS21c: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK4INCS21c)
      }
      return total;
    },
     totalHK5INCS21D_i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK5INCS21D_i)
      }
      return total;
    },
     totalHK5INCS21D_ii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK5INCS21D_ii)
      }
      return total;
    },
      totalHK5INCS21D_iii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK5INCS21D_iii)
      }
      return total;
    },
      totalHK5INCS21d: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK5INCS21d)
      }
      return total;
    },
      totalHK6INCS21E_i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK6INCS21E_i)
      }
      return total;
    },
     totalHK6INCS21E_ii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK6INCS21E_ii)
      }
      return total;
    },
      totalHK6INCS21E_iii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK6INCS21E_iii)
      }
      return total;
    },
      totalHK6INCS21e: function(){
      var total = 0;
      console.log('Initial total:', total);
    console.log('Data length:', this.summaryData.dataJR5.length);
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        console.log('Adding HK6INCS21e:', this.summaryData.dataJR5[i].HK6INCS21e);
        total = Number(total) + Number(this.summaryData.dataJR5[i].HK6INCS21e)
        console.log('Running total after addition:', total);
      }
      console.log('Final total:', total);
      return total;
    },
    //  totalINCS21NA: function(){
    //   var total = 0;
    //   for(var i=0;i<this.summaryData.dataJR5.length;i++){
    //     total = Number(total) + Number(this.totalHK4INCS21b) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) 
    //     // total = Number(total) +  Number(this.summaryData.dataJR5[i].HK4INCS21B_i) + Number(this.summaryData.dataJR5[i].HK4INCS21B_ii) +  Number(this.summaryData.dataJR5[i].HK4INCS21B_iii) + Number(this.summaryData.dataJR5[i].HK4INCS21c) + Number(this.summaryData.dataJR5[i].HK5INCS21D_i) + Number(this.summaryData.dataJR5[i].HK5INCS21D_ii) + Number(this.summaryData.dataJR5[i].HK5INCS21D_iii) (this.summaryData.dataJR5[i].INCS21e_i) + Number(this.summaryData.dataJR5[i].INCS21e_ii)+ Number(this.summaryData.dataJR5[i].INCS21e_iii)
    //     // total = Number(total) +  Number(this.summaryData.dataJR5[i].totalHK4INCS21b) + Number(this.summaryData.dataJR5[i].totalHK4INCS21c) +  Number(this.summaryData.dataJR5[i].totalHK5INCS21d) + Number(this.summaryData.dataJR5[i].totalHK6INCS21e) 
    //     }
    //   return total.toFixed(2);
      
    // },
    totalINCS21NA: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalHK4INCS21b) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) 
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS21e_i) + Number(this.summaryData.dataJR5[i].INCS21e_ii)+ Number(this.summaryData.dataJR5[i].INCS21e_iii)
      // console.log (total)
      // }
      return total.toFixed(2);
    },
     totalINCS21KS: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS21KS)
      }
      return total.toFixed(2);
    },
      totalINCS21: function(){
      var total = 0;
        total = Number(total) + Number(this.totalHK2INCS21A) + Number(this.totalHK4INCS21b) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) + Number(this.totalINCS21KS) 
      return total;
    },
     totalINCS22: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS22)
      }
      return total;
    },
      totalINCS23: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS23)
      }
      return total;
    },
      totalINCS24: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS24)
      }
      return total;
    },
      totalINCS02: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
      total = Number(total) + Number(this.summaryData.dataJR5[i].HK2INCS21a) + Number(this.summaryData.dataJR5[i].HK3INCS21a) + 
              Number(this.summaryData.dataJR5[i].HK4INCS21b) + 
              Number(this.summaryData.dataJR5[i].HK4INCS21c) + Number(this.summaryData.dataJR5[i].HK5INCS21d) + 
              Number(this.summaryData.dataJR5[i].HK6INCS21e) + Number(this.summaryData.dataJR5[i].INCS21KS) + 
              Number(this.summaryData.dataJR5[i].INCS22) + Number(this.summaryData.dataJR5[i].INCS23) + 
              Number(this.summaryData.dataJR5[i].INCS24) 
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        // total = Number(total) + Number(this.totalINCS21) + Number(this.totalINCS22) + Number(this.totalINCS23) + Number(this.totalINCS24)  
      }
      return total;
    },
     totalINCS31: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS31)
      }
      return total;
    },
     totalINCS32a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS32a)
      }
      return total;
    },
      totalINCS32b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS32b)
      }
      return total;
    },
      totalINCS32: function(){
      var total = 0;
      //for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS32a) + Number(this.totalINCS32b)
      //}
      return total;
    },
      totalINCS33: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS33)
      }
      return total;
    },
      totalINCS34: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS34)
      }
      return total;
    },
      totalINCS03: function(){
      var total = 0;
  
         total = Number(total) + Number(this.totalINCS31) + Number(this.totalINCS32) + Number(this.totalINCS33) + Number(this.totalINCS34)
        return total.toFixed(2);
    },
     totalINCS41a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS41a)
      }
      return total;
    },
      totalINCS41b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS41b)
      }
      return total;
    },
      totalINCS41: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS41)
      }
      return total;
    },
      totalINCS42: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS42)
      }
      return total;
    },
      totalINCS43: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS43)
      }
      return total;
    },
      totalINCS44: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS44)
      }
      return total;
    },
      totalINCS45a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45a)
      }
      return total;
    },
      totalINCS45b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45b)
      }
      return total;
    },
      totalINCS45c: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45c)
      }
      return total;
    },
      totalINCS45d: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45d)
      }
      return total;
    },
      totalINCS45e: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45e)
      }
      return total;
    },
      totalINCS45f: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45f)
      }
      return total;
    },
      totalINCS45g: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45g)
      }
      return total;
    },
      totalINCS45h: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45h)
      }
      return total;
    },
      totalINCS45i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45i)
      }
      return total;
    },
      totalINCS45j: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45j)
      }
      return total;
    },
      totalINCS45k: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45k)
      }
      return total;
    },
      totalINCS45l: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45l)
      }
      return total;
    },
      totalINCS45m: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45m)
      }
      return total;
    },
      totalINCS45: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS45)
      }
      return total;
    },
      totalINCS46a_i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46a_i)
      }
      return total;
    },
      totalINCS46a_ii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46a_ii)
      }
      return total;
    },
      totalINCS46a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46a)
      }
      return total;
    },
      totalINCS46b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46b)
      }
      return total;
    },
      totalINCS46c: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46c)
      }
      return total;
    },
      totalINCS46d_i: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46d_i)
      }
      return total;
    },
      totalINCS46d_ii: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46d_ii)
      }
      return total;
    },
      totalINCS46d: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46d)
      }
      return total;
    },
      totalINCS46e: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46e)
      }
      return total;
    },
      totalINCS46f: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46f)
      }
      return total;
    },
      totalINCS46: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS46)
      }
      return total;
    },
      totalINCS05: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS41) + Number(this.summaryData.dataJR5[i].INCS42)+ Number(this.summaryData.dataJR5[i].INCS43) + Number(this.summaryData.dataJR5[i].INCS44) + Number(this.summaryData.dataJR5[i].INCS45) + Number(this.summaryData.dataJR5[i].INCS46)
        
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS41) + Number(this.summaryData.dataJR5[i].INCS42) + Number(this.summaryData.dataJR5[i].INCS43) + Number(this.summaryData.dataJR5[i].INCS44) + Number(this.summaryData.dataJR5[i].INCS45) + Number(this.summaryData.dataJR5[i].INCS46)
      }
      return total.toFixed(2);
    },
      totalTP73: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].TP73)
      }
      return total.toFixed(2);
    },  
      totalINCS06: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS05) - Number(this.totalTP73) 
        // total = Number(total) + Number(this.totalINCS05) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) 
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS06)
      //}
      return total.toFixed(2);
    },
      totalINCS07: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS01) + Number(this.totalINCS02) + Number(this.totalINCS03) + Number(this.totalINCS05)
      // }
      return total.toFixed(2);
    },
      totalINCS08: function(){
      var total = 0;
      // for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.totalINCS01) + Number(this.totalINCS02) + Number(this.totalINCS03) + Number(this.totalINCS06)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS08)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS01) + Number(this.summaryData.dataJR5[i].INCS02) + Number(this.summaryData.dataJR5[i].INCS03) + Number(this.summaryData.dataJR5[i].INCS06) 
      // }
      return total.toFixed(2);
    },
      totalINCS9a: function(){
        var total = 0;
        if (this.S == 1){
            for(var i=0;i<this.summaryData.dataBLK_VII_IMBANG.length;i++){
              total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9a)
            }
        }
        if (this.S == 2){
            for(var x=0;x<this.summaryData.dataPER9.length;x++){
              total = Number(total) + Number(this.summaryData.dataPER9[x].JUM9a)
            }
        }  
        return total;
    },
      totalINCS9b: function(){
        var total = 0;
        if (this.S == 1){
            for(var i=0;i<this.summaryData.dataBLK_VII_IMBANG.length;i++){
              total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9b)
            }
        }
        if (this.S == 2){
            for(var x=0;x<this.summaryData.dataPER9.length;x++){
              total = Number(total) + Number(this.summaryData.dataPER9[x].JUM9b)
            }
        }  
        return total;
    },
      totalINCS9c: function(){
        var total = 0;
        if (this.S == 1){
            for(var i=0;i<this.summaryData.dataBLK_VII_IMBANG.length;i++){
              total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9c)
            }
        }
        if (this.S == 2){
            for(var x=0;x<this.summaryData.dataPER9.length;x++){
              total = Number(total) + Number(this.summaryData.dataPER9[x].JUM9c)
            }
        }  
        return total;
    },
      totalINCS9d: function(){
        var total = 0;
        if (this.S == 1){
            for(var i=0;i<this.summaryData.dataBLK_VII_IMBANG.length;i++){
              total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9d)
            }
        }
        if (this.S == 2){
            for(var x=0;x<this.summaryData.dataPER9.length;x++){
              total = Number(total) + Number(this.summaryData.dataPER9[x].JUM9d)
            }
        }  
        return total;
    },
      totalINCS9e: function(){
        var total = 0;
        if (this.S == 1){
            for(var i=0;i<this.summaryData.dataBLK_VII_IMBANG.length;i++){
              total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9e)
            }
        }
        if (this.S == 2){
            for(var x=0;x<this.summaryData.dataPER9.length;x++){
              total = Number(total) + Number(this.summaryData.dataPER9[x].JUM9e)
            }
        }  
        return total;
    },
    //   totalINCS09: function(){
    //   var total = 0;
    //   for(var i=0;i<this.summaryData.dataJR5.length;i++){
    //     total = Number(total) + Number(this.summaryData.dataJR5[i].INCS9a) + Number(this.summaryData.dataJR5[i].INCS9b) + Number(this.summaryData.dataJR5[i].INCS9c) + Number(this.summaryData.dataJR5[i].INCS9d) + Number(this.summaryData.dataJR5[i].INCS9e)
    //   }
    //   return total;
    // },
       totalINCS09: function(){
        var total = 0;
        if (this.S == 1){
            for(var i=0;i<this.summaryData.dataBLK_VII_IMBANG.length;i++){
              total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].INCS09)
              // total = Number(total) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9a) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9b) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9c) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9d) + Number(this.summaryData.dataBLK_VII_IMBANG[i].JUM9e)
            }
        }
        if (this.S == 2){
          
            for(var x=0;x<this.summaryData.dataPER9.length;x++){
              total = Number(total) + Number(this.summaryData.dataPER9[x].INCS09)
              // total = Number(total) + Number(this.summaryData.dataPER9[i].JUM9a) + Number(this.summaryData.dataPER9[i].JUM9b) + Number(this.summaryData.dataPER9[i].JUM9c) + Number(this.summaryData.dataPER9[i].JUM9d) + Number(this.summaryData.dataPER9[i].JUM9e)
            }
        }  
        return total;
    },
      totalINCS10_a: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_a)
      }
      return total;
    },
      totalINCS10_b: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_b)
      }
      return total;
    },
      totalINCS10_c: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_c)
      }
      return total;
    },
      totalINCS10_d: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_d)
      }
      return total;
    },
      totalINCS10_e: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_e)
      }
      return total;
    },
      totalINCS10_f: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_f)
      }
      return total;
    },
      totalINCS10_g: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_g)
      }
      return total;
    },
      totalINCS10_h: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_h)
      }
      return total;
    },
      totalINCS10: function(){
      var total = 0;
      for(var i=0;i<this.summaryData.dataJR5.length;i++){
        total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10)
        // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS10_a) + Number(this.summaryData.dataJR5[i].INCS10_b) + Number(this.summaryData.dataJR5[i].INCS10_c) + Number(this.summaryData.dataJR5[i].INCS10_di) + Number(this.summaryData.dataJR5[i].INCS10_dii) + Number(this.summaryData.dataJR5[i].INCS10_d) + Number(this.summaryData.dataJR5[i].INCS10_ei) + Number(this.summaryData.dataJR5[i].INCS10_eii) + Number(this.summaryData.dataJR5[i].INCS10_e) + Number(this.summaryData.dataJR5[i].INCS10_f)
      }
      return total;
    },

  }
}
</script>

<style>
#app{
  /* background: url('https://chatbot.dosm.gov.my/admin/files/dosm/images/chatbot/chatbotlogo.jpg') */
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}
</style>

